import { Component, EventEmitter, Input, Output } from '@angular/core';
import startCase from 'lodash/startCase';
import { Subject } from 'rxjs';
import { CustomComponent, POST_NUMBER_LENGTHS } from '@cakeiteasy/web-utils';
import { map, debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'post-number-delivery-check',
  templateUrl: './post-number-delivery-check.component.html',
  styleUrls: ['./post-number-delivery-check.components.scss'],
})
export class PostNumberDeliveryCheckComponent extends CustomComponent {
  @Input() public cityName: string;
  @Input() public countryCode: string;
  @Input() public postNumberChecker: (countryCode: string,
                                      postNumber: string) => Promise<any[]>;

  @Output() onCityChosen = new EventEmitter<{ name: string, postNumber: string }>();
  @Output() onPostNumberChosen = new EventEmitter<string>();

  public isDifferentCity: boolean = true;
  public isReady: boolean = false;
  public postNumber: string;
  public foundCityName: string = null;
  public onPostNumberUpdated$ = new Subject<string>();
  public busy: Promise<any>;

  constructor() {
    super();

    this.clear();
    this.subscribe();
  }

  public clear() {
    this.isReady = false;
    this.postNumber = '';
    this.foundCityName = '';
  }

  public submit() {
    if (this.isDifferentCity) {
      this.onCityChosen.emit({
        name: this.foundCityName,
        postNumber: this.postNumber
      });
    } else {
      this.onPostNumberChosen.emit(this.postNumber);
    }

    this.clear();
  }

  public subscribe() {
    this.addSubscriber(this.onPostNumberUpdated$
      .pipe(map((postNumber) => {
        if (!postNumber) {
          this.clear();
        }

        if (postNumber.length !== POST_NUMBER_LENGTHS[this.countryCode]) {
          this.isReady = false;
        }

        return postNumber;
      }))
      .pipe(debounceTime(350))
      .pipe(distinctUntilChanged())
      .pipe(filter((postNumber) => (Boolean(postNumber) && postNumber.length === POST_NUMBER_LENGTHS[this.countryCode])))
      .pipe(switchMap(() => this.getCityName(this.postNumber)))
      .subscribe((cityName) => this.foundCityName = cityName));
  }

  public getCityName(postNumber) {
    this.isDifferentCity = false;
    this.isReady = false;

    return this.busy = this.postNumberChecker(this.countryCode, postNumber)
      .then((bakeries) => {
        this.isReady = true;
        return bakeries.length ? startCase(this.cityName) : null;
      })
      .catch((errRes) => {
        this.isReady = true;

        if (errRes.status === 400 && errRes.error.city) {
          this.isDifferentCity = true;
          let { name, placeName } = errRes.error.city;
          return placeName || name;
        }

        return null;
      });
  }
}
